import { render, staticRenderFns } from "./changeVote.vue?vue&type=template&id=112a0f87&scoped=true&"
import script from "./changeVote.vue?vue&type=script&lang=js&"
export * from "./changeVote.vue?vue&type=script&lang=js&"
import style0 from "./changeVote.vue?vue&type=style&index=0&id=112a0f87&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a0f87",
  null
  
)

export default component.exports